<template>
  <div class="flex flex-col min-h-full bg-cream px-3 pt-12 pb-24">
    <div class="flex items-center justify-between min-h-11 mb-5">
      <h1 class="text-26 font-bold text-ink">Профиль</h1>
      <!-- Гостю тоже (решение владельца 26.10.2026): настройки живут на его
           строке и при входе в существующий аккаунт переезжают (link-guest) -->
      <router-link
        to="/profile/settings"
        class="btn-pill active:opacity-60 transition-opacity"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#41291A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="3"/>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
        </svg>
        <span>настройки дневника</span>
      </router-link>
    </div>


    <!-- Авторизован -->
    <template v-if="authStore.user">
      <!-- Аватар + имя + email + sub badge -->
      <div
        class="profile-identity flex items-center gap-4 mb-7 cursor-pointer active:opacity-70"
        @click="authStore.isGuest ? authStore.openAuthPopup() : $router.push('/profile/account')"
      >
        <img
          v-if="avatarDisplaySrc && !avatarBroken"
          :src="avatarDisplaySrc"
          class="w-[67px] h-[67px] rounded-full object-cover shrink-0"
          alt="avatar"
          @error="avatarBroken = true"
        />
        <ProfileAvatarPlaceholder v-else />
        <div class="flex-1 min-w-0">
          <p class="identity-name text-18 font-bold text-ink break-words">{{ authStore.user.name_display || authStore.user.name }}</p>
          <p v-if="authStore.isGuest" class="text-13 text-warm font-medium">Войти / Зарегистрироваться</p>
          <p v-else class="identity-email text-13 break-all" style="color: var(--ink-70)">{{ displayEmail(authStore.user.email) || 'Без email' }}</p>
        </div>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" :stroke="authStore.isGuest ? '#B98A5E' : '#41291A'" stroke-width="2" stroke-linecap="round" class="shrink-0"><path d="M9 6l6 6-6 6"/></svg>
      </div>

      <!-- Баннер «Установить приложение» (только в браузере, не в PWA) -->
      <router-link
        v-if="showInstallBanner"
        to="/help/install"
        class="flex items-center gap-3 bg-white rounded-2xl px-4 py-3 mb-6"
      >
        <img src="/icon-192.png" alt="Zoya" class="w-[40px] h-[40px] rounded-[10px]" />
        <div class="flex-1 min-w-0">
          <p style="font-family: Inter, sans-serif; font-size: var(--fs-14); font-weight: 600;" class="text-ink">Установить приложение</p>
          <p style="font-family: Inter, sans-serif; font-size: var(--fs-14); font-weight: 400;" class="text-ink/70">Добавьте Зою на Главный экран</p>
        </div>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C4B8A8" stroke-width="2" stroke-linecap="round"><path d="M9 6l6 6-6 6"/></svg>
      </router-link>

      <!-- =============================== -->
      <!-- 1. Моё тело -->
      <!-- =============================== -->
      <router-link to="/profile/body" class="block" :class="(authStore.user.height_cm || authStore.user.weight_kg) ? 'mb-6' : 'mb-3'">
        <template v-if="authStore.user.height_cm || authStore.user.weight_kg">
          <div class="flex items-center justify-between mb-2">
            <h2 class="text-20 font-bold text-ink">Моё тело</h2>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#41291A" stroke-width="2" stroke-linecap="round"><path d="M9 6l6 6-6 6"/></svg>
          </div>
          <div class="flex flex-col">
            <!-- Пол и дата рождения нужны нормам, но в карточке не отображаются —
                 без подсказки их пропуск невидим: карточка выглядит заполненной,
                 а «Норма калорий» ниже вечно пустая. Паттерн строки — как у
                 «Доля жировой ткани → рассчитать», акцент #B98A5E означает
                 «нужно действие» (как у «Войти / Зарегистрироваться»). -->
            <div v-if="!u.sex" class="pill-row pill-main pill-bold">
              <span>Пол</span><span class="font-medium" style="color: var(--warm)">указать</span>
            </div>
            <div v-if="!u.birth_date" class="pill-row pill-main pill-bold">
              <span>Дата рождения</span><span class="font-medium" style="color: var(--warm)">указать</span>
            </div>
            <div v-if="authStore.user.height_cm" class="pill-row pill-main pill-bold">
              <span>Рост</span><span class="font-semibold">{{ authStore.user.height_cm }} см</span>
            </div>
            <div v-if="authStore.user.weight_kg" class="pill-row pill-main pill-bold">
              <span>Вес сейчас</span><span class="font-semibold">{{ authStore.user.weight_kg }} кг</span>
            </div>
            <div v-if="u.bmi" class="pill-row pill-main pill-bold">
              <span>ИМТ</span><span class="font-semibold">{{ u.bmi }}</span>
            </div>
            <div class="pill-row pill-main pill-bold">
              <span>Доля жировой ткани</span>
              <span v-if="lastBodyFat !== null" class="font-semibold">{{ lastBodyFat }}%</span>
              <span v-else class="text-ink">рассчитать</span>
            </div>
          </div>
        </template>
        <div v-else class="empty-card empty-card-brown">
          <div class="empty-card-header">
            <h2 class="empty-card-title">Моё тело</h2>
            <div class="empty-card-action">
              <span class="empty-card-link">заполнить</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#41291A" stroke-width="2" stroke-linecap="round"><path d="M9 6l6 6-6 6"/></svg>
            </div>
          </div>
        </div>
      </router-link>

      <!-- =============================== -->
      <!-- 2. Норма калорий -->
      <!-- =============================== -->
      <div :class="hasNorms ? 'mb-6' : 'mb-3'">
        <template v-if="hasNorms">
        <div class="section-header mb-2">
          <h2 class="text-20 font-bold text-ink">Норма калорий</h2>
          <button class="info-btn" @click="openPopup('formula')">
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none">
              <circle cx="11" cy="11" r="10" stroke="#B98A5E" stroke-width="1.5"/>
              <text x="11" y="15.5" text-anchor="middle" fill="#B98A5E" font-size="13" font-weight="600" font-family="inherit">i</text>
            </svg>
          </button>
        </div>
        <div class="flex flex-col">
          <div class="pill-row pill-basal pill-bold">
            <span>Базовый метаболизм (BMR)</span><span class="font-semibold">{{ u.basal_met }}</span>
          </div>
          <div class="pill-row pill-main pill-bold">
            <span>Поддержание веса</span>
            <span class="flex items-center gap-1.5">
              <button @click="openPopup('customKcal')" class="info-btn">
                <svg width="18" height="18" viewBox="0 0 14 14" fill="none" style="opacity:0.8"><path d="M4.5 11V6" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.5 6C5.32843 6 6 5.32843 6 4.5C6 3.67157 5.32843 3 4.5 3C3.67157 3 3 3.67157 3 4.5C3 5.32843 3.67157 6 4.5 6Z" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 3V6" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 9V11" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 9C10.3284 9 11 8.32843 11 7.5C11 6.67157 10.3284 6 9.5 6C8.67157 6 8 6.67157 8 7.5C8 8.32843 8.67157 9 9.5 9Z" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
              <span class="font-semibold">{{ effectiveKcalNorm }}</span>
            </span>
          </div>
          <div class="pill-row pill-main pill-bold">
            <span>{{ effectiveDeficitPct === 0 ? 'Установить % дефицита' : `Похудение с дефицитом ${effectiveDeficitPct}%` }}</span>
            <span class="flex items-center gap-1.5">
              <button @click="openPopup('customDeficit')" class="info-btn">
                <svg width="18" height="18" viewBox="0 0 14 14" fill="none" style="opacity:0.8"><path d="M4.5 11V6" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.5 6C5.32843 6 6 5.32843 6 4.5C6 3.67157 5.32843 3 4.5 3C3.67157 3 3 3.67157 3 4.5C3 5.32843 3.67157 6 4.5 6Z" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 3V6" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 9V11" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 9C10.3284 9 11 8.32843 11 7.5C11 6.67157 10.3284 6 9.5 6C8.67157 6 8 6.67157 8 7.5C8 8.32843 8.67157 9 9.5 9Z" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
              <span class="font-semibold">{{ deficitKcal }}</span>
            </span>
          </div>
        </div>
        </template>
        <div v-else class="empty-card empty-card-gold">
          <h2 class="empty-card-title">Норма калорий</h2>
          <p v-if="missingNormFields.length" class="empty-card-desc">Для расчёта не хватает: {{ missingNormFieldsText }}. Укажите в разделе «Моё тело»</p>
          <p v-else class="empty-card-desc">Заполните разделы выше и нормы рассчитаются автоматически</p>
        </div>
      </div>

      <!-- =============================== -->
      <!-- 3. Нормы нутриентов -->
      <!-- =============================== -->
      <div :class="hasNorms ? 'mb-6' : 'mb-3'">
        <template v-if="hasNorms">
        <div class="section-header mb-2">
          <h2 class="text-20 font-bold text-ink">Нормы нутриентов</h2>
          <button class="info-btn" @click="openPopup('method')">
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none">
              <circle cx="11" cy="11" r="10" stroke="#B98A5E" stroke-width="1.5"/>
              <text x="11" y="15.5" text-anchor="middle" fill="#B98A5E" font-size="13" font-weight="600" font-family="inherit">i</text>
            </svg>
          </button>
        </div>
        <div class="flex flex-col">
          <div class="pill-row pill-bold" style="background: #9FC2C1;">
            <span class="text-ink">Белок</span>
            <span class="flex items-center gap-1.5">
              <button @click="openPopup('customProtein')" class="info-btn">
                <svg width="18" height="18" viewBox="0 0 14 14" fill="none" style="opacity:0.8"><path d="M4.5 11V6" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.5 6C5.32843 6 6 5.32843 6 4.5C6 3.67157 5.32843 3 4.5 3C3.67157 3 3 3.67157 3 4.5C3 5.32843 3.67157 6 4.5 6Z" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 3V6" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 9V11" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 9C10.3284 9 11 8.32843 11 7.5C11 6.67157 10.3284 6 9.5 6C8.67157 6 8 6.67157 8 7.5C8 8.32843 8.67157 9 9.5 9Z" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
              <span class="text-ink font-semibold">{{ effectiveProteinMin }}–{{ effectiveProteinMax }} г</span>
            </span>
          </div>
          <div class="pill-row pill-bold" style="background: #EBC06D;">
            <span class="text-ink">Жиры</span>
            <span class="flex items-center gap-1.5">
              <button @click="openPopup('customFat')" class="info-btn">
                <svg width="18" height="18" viewBox="0 0 14 14" fill="none" style="opacity:0.8"><path d="M4.5 11V6" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.5 6C5.32843 6 6 5.32843 6 4.5C6 3.67157 5.32843 3 4.5 3C3.67157 3 3 3.67157 3 4.5C3 5.32843 3.67157 6 4.5 6Z" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 3V6" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 9V11" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 9C10.3284 9 11 8.32843 11 7.5C11 6.67157 10.3284 6 9.5 6C8.67157 6 8 6.67157 8 7.5C8 8.32843 8.67157 9 9.5 9Z" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
              <span class="text-ink font-semibold">{{ effectiveFatMin }}–{{ effectiveFatMax }} г</span>
            </span>
          </div>
          <!-- Справочный ориентир по абсолютной омега-3; цвет — как полоска
               «Омега-3» в дневнике -->
          <div class="pill-row pill-bold" style="background: #eecf8a;">
            <span class="text-ink">Омега-3</span><span class="text-ink font-semibold">1–2 г</span>
          </div>
          <div class="pill-row pill-bold" style="background: #EEAD77;">
            <span class="text-ink">Углеводы</span>
            <span class="flex items-center gap-1.5">
              <button @click="openPopup('customCarbs')" class="info-btn">
                <svg width="18" height="18" viewBox="0 0 14 14" fill="none" style="opacity:0.8"><path d="M4.5 11V6" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.5 6C5.32843 6 6 5.32843 6 4.5C6 3.67157 5.32843 3 4.5 3C3.67157 3 3 3.67157 3 4.5C3 5.32843 3.67157 6 4.5 6Z" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 3V6" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 9V11" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 9C10.3284 9 11 8.32843 11 7.5C11 6.67157 10.3284 6 9.5 6C8.67157 6 8 6.67157 8 7.5C8 8.32843 8.67157 9 9.5 9Z" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
              <span class="text-ink font-semibold">{{ effectiveCarbsMin }}–{{ effectiveCarbsMax }} г</span>
            </span>
          </div>
          <div class="pill-row pill-bold" style="background: #A6B779;">
            <span class="text-ink">Клетчатка</span><span class="text-ink font-semibold">25–35 г</span>
          </div>
        </div>
        </template>
        <div v-else class="empty-card empty-card-gold">
          <h2 class="empty-card-title">Нормы нутриентов</h2>
          <p class="empty-card-desc">Нормы БЖУ и клетчатки рассчитаются автоматически</p>
        </div>
      </div>

      <!-- =============================== -->
      <!-- 4. Ограничения -->
      <!-- =============================== -->
      <div :class="hasNorms ? 'mb-6' : 'mb-3'">
        <template v-if="hasNorms">
        <div class="section-header mb-2">
          <h2 class="text-20 font-bold text-ink">Ограничения</h2>
          <button class="info-btn" @click="openPopup('sources')">
            <svg width="18" height="18" viewBox="0 0 22 22" fill="none">
              <circle cx="11" cy="11" r="10" stroke="#B98A5E" stroke-width="1.5"/>
              <text x="11" y="15.5" text-anchor="middle" fill="#B98A5E" font-size="13" font-weight="600" font-family="inherit">i</text>
            </svg>
          </button>
        </div>
        <div class="flex flex-col">
          <!-- Цвет — как у полоски «Насыщенные жиры» в дневнике: цветовое
               кодирование нутриентов сквозное через весь проект -->
          <div class="pill-row pill-bold" style="background: #d7aa49;">
            <span>Насыщенные жиры</span><span class="font-semibold">до {{ u.saturated_fat_limit }} г</span>
          </div>
          <div class="pill-row pill-basal pill-bold">
            <span>Добавленный сахар</span><span class="font-semibold">до {{ u.added_sugar_limit }} г</span>
          </div>
        </div>
        </template>
        <div v-else class="empty-card empty-card-peach">
          <h2 class="empty-card-title">Ограничения</h2>
          <p class="empty-card-desc">Лимиты по сахару и насыщенным жирам рассчитаются автоматически</p>
        </div>
      </div>

      <!-- =============================== -->
      <!-- 5. Физическая активность -->
      <!-- =============================== -->
      <router-link to="/profile/activity" class="block" :class="hasActivity ? 'mb-6' : 'mb-3'">
        <template v-if="hasActivity">
          <div class="flex items-center justify-between mb-2">
            <div class="section-header">
              <h2 class="text-20 font-bold text-ink">Активность</h2>
              <button class="info-btn" @click.stop.prevent="openPopup('activity')">
                <svg width="18" height="18" viewBox="0 0 22 22" fill="none">
                  <circle cx="11" cy="11" r="10" stroke="#B98A5E" stroke-width="1.5"/>
                  <text x="11" y="15.5" text-anchor="middle" fill="#B98A5E" font-size="13" font-weight="600" font-family="inherit">i</text>
                </svg>
              </button>
            </div>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#41291A" stroke-width="2" stroke-linecap="round"><path d="M9 6l6 6-6 6"/></svg>
          </div>
          <div v-if="effectiveActivityCoefficient || authStore.palLoading" class="pill-row pill-main mb-1" style="align-items: flex-start;">
            <span style="padding-top: 2px;">Коэффициент активности</span>
            <div class="flex items-start gap-1.5">
              <!-- Ручная установка — по образцу нормы белка. Карточка целиком
                   ссылка на анкету, поэтому stop.prevent -->
              <button @click.stop.prevent="openPopup('customActivity')" class="info-btn" style="margin-top: 1px;">
                <svg width="18" height="18" viewBox="0 0 14 14" fill="none" style="opacity:0.8"><path d="M4.5 11V6" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.5 6C5.32843 6 6 5.32843 6 4.5C6 3.67157 5.32843 3 4.5 3C3.67157 3 3 3.67157 3 4.5C3 5.32843 3.67157 6 4.5 6Z" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 3V6" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 9V11" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 9C10.3284 9 11 8.32843 11 7.5C11 6.67157 10.3284 6 9.5 6C8.67157 6 8 6.67157 8 7.5C8 8.32843 8.67157 9 9.5 9Z" stroke="#41291A" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
              <div class="text-right">
                <template v-if="authStore.palLoading">
                  <div class="flex items-center gap-1.5">
                    <div class="w-3.5 h-3.5 border-2 border-[#E5E5E5] border-t-[#41291A] rounded-full animate-spin" />
                    <span class="text-12 text-ink/70">пересчёт...</span>
                  </div>
                </template>
                <template v-else>
                  <!-- Сначала полоса словами, число вторым: само по себе 1.8 человек
                       читает по шкале калькуляторов (1.2–1.9) как «очень высокая». -->
                  <span class="font-semibold">{{ activityLabel }}</span>
                  <p class="text-13 leading-tight" style="color: var(--ink-70);">{{ effectiveActivityCoefficient }}{{ u.custom_activity_coefficient ? ' · задан вручную' : ' по шкале ВОЗ' }}</p>
                </template>
              </div>
            </div>
          </div>
          <div v-for="(line, i) in activityPills" :key="i" class="pill-row pill-main">
            <span>{{ line.label }}</span><span>{{ line.value }}</span>
          </div>
        </template>
        <div v-else class="empty-card empty-card-brown">
          <div class="empty-card-header">
            <h2 class="empty-card-title">Активность</h2>
            <div class="empty-card-action">
              <span class="empty-card-link">заполнить</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#41291A" stroke-width="2" stroke-linecap="round"><path d="M9 6l6 6-6 6"/></svg>
            </div>
          </div>
        </div>
      </router-link>

      <!-- =============================== -->
      <!-- 7. Цели -->
      <!-- =============================== -->
      <router-link to="/profile/goals" class="block" :class="hasGoals ? 'mb-8' : 'mb-4'">
        <template v-if="hasGoals">
          <div class="flex items-center justify-between mb-2">
            <h2 class="text-20 font-bold text-ink">Цели</h2>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#41291A" stroke-width="2" stroke-linecap="round"><path d="M9 6l6 6-6 6"/></svg>
          </div>
          <div v-for="(goal, i) in goalPills" :key="i"
               class="pill-row pill-main leading-snug">
            {{ goal }}
          </div>
        </template>
        <div v-else class="empty-card empty-card-brown">
          <div class="empty-card-header">
            <h2 class="empty-card-title">Цели</h2>
            <div class="empty-card-action">
              <span class="empty-card-link">заполнить</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#41291A" stroke-width="2" stroke-linecap="round"><path d="M9 6l6 6-6 6"/></svg>
            </div>
          </div>
        </div>
      </router-link>

      <!-- =============================== -->
      <!-- 8. Продукты в рационе: исключения и предпочтения -->
      <!-- =============================== -->
      <router-link to="/profile/allergies" class="block" :class="(authStore.user.allergies || authStore.user.food_preferences) ? 'mb-8' : 'mb-4'">
        <template v-if="authStore.user.allergies || authStore.user.food_preferences">
          <div class="flex items-center justify-between mb-2">
            <h2 class="text-20 font-bold text-ink leading-[1.1]">Продукты в рационе</h2>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#41291A" stroke-width="2" stroke-linecap="round"><path d="M9 6l6 6-6 6"/></svg>
          </div>
          <div v-if="authStore.user.allergies" class="pill-row pill-main mb-1" style="align-items: flex-start;">
            <span style="white-space: nowrap;">Исключения</span>
            <span class="flex-1 text-left ml-3">{{ authStore.user.allergies }}</span>
          </div>
          <div v-if="authStore.user.food_preferences" class="pill-row pill-main" style="align-items: flex-start;">
            <span style="white-space: nowrap;">Предпочтения</span>
            <span class="flex-1 text-left ml-3">{{ authStore.user.food_preferences }}</span>
          </div>
        </template>
        <div v-else class="empty-card empty-card-brown">
          <div class="empty-card-header">
            <h2 class="empty-card-title">Продукты<br>в рационе</h2>
            <div class="empty-card-action">
              <span class="empty-card-link">заполнить</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#41291A" stroke-width="2" stroke-linecap="round"><path d="M9 6l6 6-6 6"/></svg>
            </div>
          </div>
          <p class="empty-card-desc">Заполните раздел, чтобы рекомендации по питанию учитывали ваши особенности</p>
        </div>
      </router-link>

      <!-- =============================== -->
      <!-- 9. Рекомендации по питанию -->
      <!-- =============================== -->
      <router-link to="/profile/nutrition" class="block" :class="nutritionSummary ? 'mb-8' : 'mb-4'">
        <template v-if="nutritionSummary">
          <div class="flex items-center justify-between mb-2">
            <h2 class="text-20 font-bold text-ink leading-[1.1]">Рекомендации по питанию</h2>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#41291A" stroke-width="2" stroke-linecap="round"><path d="M9 6l6 6-6 6"/></svg>
          </div>
          <div class="pill-row pill-main" style="align-items: flex-start;">
            <span class="flex-1 text-left">{{ nutritionSummary }}</span>
          </div>
        </template>
        <div v-else class="empty-card empty-card-brown">
          <div class="empty-card-header">
            <h2 class="empty-card-title">Рекомендации<br>по питанию</h2>
            <div class="empty-card-action">
              <span class="empty-card-link">заполнить</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#41291A" stroke-width="2" stroke-linecap="round"><path d="M9 6l6 6-6 6"/></svg>
            </div>
          </div>
          <p class="empty-card-desc">Отметьте, что учитывать в рационе — Зоя будет держать это в виду при анализе и в чате</p>
        </div>
      </router-link>

      <!-- Ссылка на админку -->
      <router-link
        v-if="authStore.user?.is_admin"
        to="/admin"
        class="pill-row pill-main mb-6"
      >
        <span class="font-semibold">Админка Зои</span>
        <span class="text-ink/60">&rsaquo;</span>
      </router-link>

      <!-- =============================== -->
      <!-- 8. Юридическая информация -->
      <!-- =============================== -->
      <div class="mt-4 mb-4 text-center">
        <div class="flex flex-col items-center gap-1 mb-3">
          <router-link to="/legal/terms" class="text-12 text-ink/70 underline">Пользовательское соглашение</router-link>
          <router-link to="/legal/privacy" class="text-12 text-ink/70 underline">Политика обработки персональных данных</router-link>
        </div>
        <p class="text-11 text-ink/70 leading-relaxed">
          &laquo;ЗОЯ &mdash; ДНЕВНИК ПИТАНИЯ С ИИ&raquo;<br>
          ИП Кудеров Максим Сергеевич<br>
          ИНН: 632300544064, ОГРНИП: 317784700146951
        </p>
        <p class="text-11 text-ink/70 mt-3">m@zozhnik.ru</p>
      </div>
    </template>

    <!-- Не авторизован -->
    <template v-else>
      <div class="flex-1 flex flex-col items-center justify-center gap-5 py-8">
        <div class="w-16 h-16 rounded-full bg-line flex items-center justify-center">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#C4B8A8" stroke-width="1.5" stroke-linecap="round">
            <circle cx="12" cy="8" r="5"/>
            <path d="M3 21c0-4.5 4-8 9-8s9 3.5 9 8"/>
          </svg>
        </div>
        <div class="text-center">
          <p class="text-16 font-semibold text-ink">Войдите в аккаунт</p>
          <p class="text-13 text-ink/70 mt-1">Чтобы сохранять дневник и получать советы Зои</p>
        </div>
        <button
          @click="authStore.openAuthPopup()"
          class="px-8 py-3 rounded-2xl bg-ink text-cream text-16 font-semibold"
        >
          Войти / Зарегистрироваться
        </button>
      </div>
    </template>

    <!-- =============================== -->
    <!-- Popup модалки -->
    <!-- =============================== -->
    <Teleport to="body">
      <Transition name="fade">
        <div v-if="popupType" class="fixed inset-0 z-[90] flex items-end justify-center" @click.self="closePopup">
          <div class="absolute inset-0 bg-black/40" @click="closePopup" />
          <div class="relative w-full max-w-[430px] bg-cream rounded-t-2xl shadow-2xl flex flex-col sheet-inset" style="max-height: 80vh">

            <!-- Sticky заголовок + крестик -->
            <div class="shrink-0 px-5 pt-4 pb-3">
              <div class="w-10 h-1 bg-sand rounded-full mx-auto mb-4" />
              <div class="flex items-center justify-between">
                <h3 class="text-17 font-bold text-ink">
                  <template v-if="popupType === 'formula'">Формулы расчёта нормы калорий</template>
                  <template v-else-if="popupType === 'method'">Методика расчёта нутриентов</template>
                  <template v-else-if="popupType === 'sources'">Источники рекомендаций</template>
                  <template v-else-if="popupType === 'activity'">Как считается коэффициент активности</template>
                  <template v-else-if="popupType === 'customKcal'">Настройка нормы ккал</template>
                  <template v-else-if="popupType === 'customActivity'">Коэффициент активности вручную</template>
                  <template v-else-if="popupType === 'customDeficit'">Настройка % дефицита</template>
                  <template v-else-if="popupType === 'customProtein'">Настройка нормы белка</template>
                  <template v-else-if="popupType === 'customFat'">Настройка нормы жиров</template>
                  <template v-else-if="popupType === 'customCarbs'">Настройка нормы углеводов</template>
                </h3>
                <button @click="closePopup" class="w-8 h-8 flex items-center justify-center rounded-full text-ink active:bg-line transition-colors shrink-0 ml-2">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
                    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                  </svg>
                </button>
              </div>
            </div>

            <!-- Скроллируемый контент -->
            <div class="flex-1 overflow-y-auto px-5 pb-8">

              <!-- Формула -->
              <template v-if="popupType === 'formula'">
                <div class="text-14 text-ink leading-relaxed space-y-3">
                  <p><strong>Базовый метаболизм (BMR)</strong> — это количество калорий, которое организм тратит в состоянии полного покоя на поддержание жизненных функций: дыхание, кровообращение, работу мозга, терморегуляцию и обновление клеток.</p>

                  <p>Мы используем <strong>формулу Mifflin-St Jeor</strong> (1990) — она признана наиболее точной по данным Американской диетической ассоциации (ADA, 2005):</p>

                  <div class="bg-[#F0EBE3] rounded-xl px-3 py-2 font-mono text-13">
                    Мужчины: BMR = 10 &times; вес(кг) + 6.25 &times; рост(см) &minus; 5 &times; возраст + 5<br>
                    Женщины: BMR = 10 &times; вес(кг) + 6.25 &times; рост(см) &minus; 5 &times; возраст &minus; 161
                  </div>

                  <p><strong>Поддержание веса (TDEE)</strong> — суточная норма калорий с учётом физической активности. Рассчитывается как:</p>
                  <p class="bg-[#F0EBE3] rounded-xl px-3 py-2 font-mono text-13">TDEE = BMR &times; коэффициент активности (PAL)</p>
                  <p>Коэффициент активности (PAL) определяется на основе ваших данных о физической нагрузке, характере работы и количестве шагов. Диапазон: от 1.4 (сидячий образ жизни) до 2.4 (тяжёлый физический труд вместе с ежедневными тренировками). Это шкала ВОЗ/FAO, она же в российских нормах Роспотребнадзора; в онлайн-калькуляторах отсчёт идёт от 1.2, но 1.2 по измерениям — постельный режим, поэтому здесь коэффициент при тех же данных выше. Подробно — в разделе «Активность».</p>

                  <p><strong>Похудение</strong> — норма со сниженной калорийностью:</p>
                  <p class="bg-[#F0EBE3] rounded-xl px-3 py-2 font-mono text-13">Дефицит = TDEE &minus; 15%</p>
                  <p>Дефицит 15% считается умеренным и безопасным — он позволяет терять ~0.5 кг жировой массы в неделю без значительной потери мышц и замедления метаболизма. Не рекомендуется опускаться ниже BMR.</p>
                </div>
              </template>

              <!-- Коэффициент активности -->
              <template v-if="popupType === 'activity'">
                <div class="text-14 text-ink leading-relaxed space-y-3">
                  <!-- Переход на новую методику по согласию (lib/palOffer.js):
                       pal_version = 1 значит, что человека закрепили на прежней -->
                  <div v-if="palOfferAvailable" class="rounded-xl px-3 py-3" style="background: #F0EBE3;">
                    <p class="mb-3"><strong>Доступна новая методика расчёта.</strong> Она точнее учитывает рабочие дни и ходьбу по шагам. {{ ty ? 'Твоя' : 'Ваша' }} норма пока считается по прежней. Пересчитать можно сейчас или позже — норма обновится и когда {{ ty ? 'изменишь' : 'измените' }} анкету активности.</p>
                    <button @click="acceptPalV2" :disabled="savingPalVersion"
                      class="w-full py-2.5 rounded-2xl text-14 font-semibold bg-ink text-cream active:bg-[#2a1a10] disabled:opacity-60"
                    >{{ savingPalVersion ? 'Пересчитываю...' : 'Пересчитать по новой методике' }}</button>
                  </div>

                  <p><strong>Коэффициент активности</strong> показывает, во сколько раз ваш суточный расход энергии выше базового обмена. Базовый обмен — это расход в полном покое, а норма калорий получается умножением:</p>

                  <p class="bg-[#F0EBE3] rounded-xl px-3 py-2 font-mono text-13">Норма = базовый обмен &times; коэффициент активности</p>

                  <p><strong>Как он считается.</strong> Сутки разбираются по часам, и каждому часу присваивается интенсивность в MET — метаболических эквивалентах. Один MET равен расходу в покое сидя. Коэффициент — это средняя интенсивность за все 24 часа:</p>

                  <p class="bg-[#F0EBE3] rounded-xl px-3 py-2 font-mono text-13">Коэффициент = сумма (MET &times; часы) &divide; 24</p>

                  <p>Складывается он из четырёх частей.</p>

                  <!-- Описание той формулы, которой посчитан именно этот человек:
                       pal_version пишет recalcNorms (lib/pal.js, две версии) -->
                  <template v-if="palV2">
                    <p><strong>1. Сон</strong> — 8 часов, интенсивность 1.0: во сне расход равен базовому обмену.</p>

                    <p><strong>2. Работа</strong> — 8 часов, 5 дней в неделю (коэффициент — среднее за неделю): сидячая 1.5, сидячая с перерывами 1.8, на ногах 2.0, физический труд 3.0. День дома — без рабочих часов. Это интенсивности из методики ВОЗ/FAO; ходьба в них не входит и считается отдельно.</p>

                    <p><strong>3. Ходьба</strong> — по вашим шагам: около 6000 шагов это час ходьбы с интенсивностью 3.2. Остальное время бодрствования — быт, еда, дорога, отдых — идёт как 1.8 (день дома — 1.6). Если шаги не указаны, берётся типичное для вашего вида работы число.</p>
                  </template>
                  <template v-else>
                    <p><strong>1. Сон</strong> — 8 часов при интенсивности 0.95.</p>

                    <p><strong>2. Обычный день</strong> — 8 часов работы: сидячий 1.6, смешанный 2.5, активный 3.2. Эти значения подобраны так, чтобы сутки без тренировок попадали в диапазоны ВОЗ: 1.40–1.69 для сидячего образа жизни, 1.70–1.99 для умеренно активного, 2.00–2.40 для высокого.</p>

                    <p><strong>3. Шаги</strong> — отсчитываются от 6000. Примерно столько набирается за обычный день, и эта ходьба уже заложена в расчёт. Больше — коэффициент растёт, заметно меньше — снижается.</p>
                  </template>

                  <p><strong>4. Тренировки</strong> — вид, частота и длительность. Интенсивность каждого вида берётся из Compendium of Physical Activities — международного справочника, где энергозатраты сотен активностей измерены в лабораториях:</p>

                  <div class="bg-[#F0EBE3] rounded-xl px-3 py-2 text-13">
                    {{ palV2 ? 'йога — 2.3–4.0 по стилю' : 'йога — 4.5' }} &nbsp;·&nbsp; силовые — 5.0 &nbsp;·&nbsp; плавание — 7.0<br>
                    велоспорт — 7.5 &nbsp;·&nbsp; бег — 9.8 &nbsp;·&nbsp; единоборства — 10.3
                  </div>

                  <p>Поэтому час бега и час йоги считаются по-разному. Если вы вписали свою активность в поле «Другое», её интенсивность оценивается по тому же справочнику отдельно.</p>

                  <p><strong>Почему тренировки прибавляют меньше, чем ожидаешь.</strong> Час занятий — это около 1% недели, и на среднюю интенсивность суток он влияет слабее, чем на самочувствие. Кроме того, организм частично компенсирует нагрузку: после тренировки человек обычно меньше двигается в остальное время. Поэтому тренировочная прибавка учитывается с понижающим множителем {{ palV2 ? '0.75' : '0.85' }} — так показывают исследования суммарных суточных затрат.</p>

                  <p><strong>Почему число выше, чем в онлайн-калькуляторах.</strong> Там шкала начинается с 1.2 для «сидячего образа жизни» — это множители из старых формул. По измерениям методом двойной меченой воды 1.2 — это постельный режим, а обычный сидячий день без тренировок даёт 1.4–1.5. Мы считаем по шкале ВОЗ/FAO; та же шкала в российских нормах Роспотребнадзора (МР 2.3.1.0253-21: от 1.4 до 2.2). Поэтому при тех же данных коэффициент здесь примерно на 0.2 выше, чем в калькуляторах, а норма калорий — на 10–20% выше. Это не ошибка расчёта, а другая точка отсчёта.</p>

                  <p><strong>Ручная установка.</strong> Коэффициент можно задать самому — кнопка рядом с числом в карточке «Активность». Тогда анкета на коэффициент не влияет, а норма калорий считается как базовый обмен × ваше число; вместе с ней меняются лимиты углеводов и сахара, а диапазон белка пересчитывается по уровню активности, который задаёт ваше число. Если берёте число из онлайн-калькулятора, помните о другой точке отсчёта: там 1.2 означает «сидячий», здесь сидячий день без тренировок это около 1.5, и норма выйдет на 10–20% ниже нашей оценки. Любой коэффициент — и расчётный, и свой — стоит сверить с динамикой веса за 3–4 недели: если вес стоит при норме, число верное. Вернуться к расчёту по анкете можно в любой момент.</p>

                  <p><strong>Точность.</strong> Любой расчёт по анкете — это оценка. Отклонение от лабораторного измерения (метод двойной меченой воды) составляет около &plusmn;0.15. Коэффициент стоит воспринимать как отправную точку: дальше норму имеет смысл уточнять по тому, как меняется вес. Если считаете, что число вам не подходит, норму калорий можно задать вручную.</p>

                  <p class="text-13" style="color: var(--ink-70);">Коэффициент пересчитывается автоматически, когда вы меняете данные в разделе «Активность».</p>
                </div>
              </template>

              <!-- Методика -->
              <template v-if="popupType === 'method'">
                <div class="text-14 text-ink leading-relaxed space-y-3">
                  <p>Нормы макронутриентов рассчитываются индивидуально на основе вашего веса, уровня активности и целей.</p>

                  <p><strong>Белок: 0.8–2.0 г/кг массы тела</strong></p>
                  <p>Минимум 0.8 г/кг — рекомендация ВОЗ для поддержания азотистого баланса. Граммы на килограмм зависят от уровня активности по коэффициенту (до 1.7 — сидячий или лёгкий, до 2.0 — умеренный, выше — высокий) и от целей: при похудении, рекомпозиции или наборе массы диапазон выше. Сидячий день без таких целей — 0.8–1.2 г/кг, умеренная активность с целью — 1.4–1.8, высокая с целью — 1.6–2.0 (рекомендации ISSN, 2017). При избыточном весе (ИМТ &gt; 25) и цели снизить вес расчёт ведётся на <em>идеальную</em> массу тела (ИМТ 22), чтобы не завышать норму.</p>

                  <p><strong>Жиры: 0.8–1.5 г/кг массы тела</strong></p>
                  <p>Жиры необходимы для усвоения витаминов A, D, E, K, синтеза гормонов и работы нервной системы. Снижение ниже 0.8 г/кг может нарушить гормональный фон. Рекомендация ВОЗ: 20–35% калорийности рациона из жиров.</p>

                  <p><strong>Углеводы: 40–60% от суточной калорийности</strong></p>
                  <p>Основной источник энергии для мозга и мышц. Диапазон зависит от уровня активности: при высоких нагрузках ближе к 60%, при сидячем образе жизни — к 40%. 1 г углеводов = 4 ккал.</p>

                  <p><strong>Клетчатка: 25–35 г/день</strong></p>
                  <p>Рекомендация ВОЗ (2015). Клетчатка поддерживает здоровье кишечника, замедляет всасывание сахара, снижает уровень холестерина и помогает контролировать аппетит.</p>
                </div>
              </template>

              <!-- Источники -->
              <template v-if="popupType === 'sources'">
                <div class="text-14 text-ink leading-relaxed space-y-2">
                  <p><strong>Насыщенные жиры:</strong> не более 10% от суточной калорийности (1 г = 9 ккал). Рекомендация ВОЗ, 2023.</p>
                  <p><strong>Добавленный сахар:</strong> не более 10% от суточной калорийности (1 г = 4 ккал). Рекомендация ВОЗ, 2015.</p>
                </div>
              </template>

              <!-- Настройка нормы ккал -->
              <template v-if="popupType === 'customKcal'">
                <div class="text-14 text-ink leading-relaxed">
                  <p class="mb-4">Норма калорий рассчитана по {{ ty ? 'твоим' : 'вашим' }} параметрам по формуле Миффлина-Сан Жеора. Однако {{ ty ? 'ты можешь' : 'вы можете' }} указать норму вручную:</p>

                  <div class="flex justify-center mb-2">
                    <input
                      v-model="customKcalInput"
                      type="text"
                      inputmode="numeric"
                      class="w-32 h-12 text-center text-20 font-bold rounded-2xl bg-white text-ink outline-none"
                      :class="kcalBelowBmr ? 'ring-2 ring-red-500' : ''"
                    />
                  </div>
                  <p v-if="kcalBelowBmr" class="text-13 text-red-500 text-center mb-3">Норма калорий не может быть ниже базового метаболизма: {{ u.basal_met }}</p>
                  <div v-if="!kcalBelowBmr" class="mb-6"></div>

                  <button
                    @click="resetKcalToFormula"
                    :disabled="!kcalDiffersFromFormula"
                    class="w-full py-3 rounded-2xl text-15 font-semibold mb-3 transition-colors"
                    :class="kcalDiffersFromFormula ? 'bg-[#E7D9C6] text-ink active:bg-[#d9c8ae]' : 'bg-[#E7D9C6]/50 text-ink/40'"
                  >Пересчитать по формуле</button>

                  <button
                    @click="saveCustomKcal"
                    :disabled="!kcalChanged || kcalBelowBmr || savingKcal"
                    class="w-full py-3 rounded-2xl text-15 font-semibold transition-colors"
                    :class="kcalChanged && !kcalBelowBmr ? 'bg-ink text-cream active:bg-[#2a1a10]' : 'bg-ink/30 text-cream/70'"
                  >{{ savingKcal ? 'Сохраняю...' : 'Сохранить' }}</button>
                </div>
              </template>

              <!-- Ручной коэффициент активности (zoya_users.custom_activity_coefficient) -->
              <template v-if="popupType === 'customActivity'">
                <div class="text-14 text-ink leading-relaxed">
                  <p class="mb-3">По анкете активности коэффициент <strong>{{ u.activity_coefficient || '—' }}</strong>. {{ ty ? 'Ты можешь' : 'Вы можете' }} задать его вручную — например, по данным трекера или если {{ ty ? 'привык' : 'привыкли' }} к другой шкале:</p>

                  <div class="flex justify-center mb-2">
                    <input
                      v-model="customPalInput"
                      type="text"
                      inputmode="decimal"
                      class="w-32 h-12 text-center text-20 font-bold rounded-2xl bg-white text-ink outline-none"
                      :class="customPalError ? 'ring-2 ring-red-500' : ''"
                    />
                  </div>
                  <p v-if="customPalError" class="text-13 text-red-500 text-center mb-3">{{ customPalError }}</p>
                  <p v-else-if="customPalPreview" class="text-13 text-center mb-3" style="color: var(--ink-70);">Норма калорий станет {{ customPalPreview }} ккал</p>
                  <div v-else class="mb-3"></div>

                  <p v-if="customPalLow" class="text-13 mb-3 rounded-xl px-3 py-2" style="background: #F0EBE3;">Ниже 1.4 — по измерениям это постельный режим, норма выйдет заниженной. В онлайн-калькуляторах 1.2 подписан как «сидячий», но здесь сидячий день без тренировок это около 1.5.</p>

                  <p class="text-13 mb-4" style="color: var(--ink-70);">Пока задан ручной коэффициент, анкета активности на норму не влияет. От коэффициента зависят норма калорий и лимиты углеводов и сахара, а также диапазон белка: граммы на килограмм берутся по уровню активности (до 1.7, до 2.0, выше) и целям, затем умножаются на вес. Вернуться к расчёту можно в любой момент.</p>

                  <button
                    @click="resetCustomPal"
                    :disabled="!customPalDiffersFromFormula"
                    class="w-full py-3 rounded-2xl text-15 font-semibold mb-3 transition-colors"
                    :class="customPalDiffersFromFormula ? 'bg-[#E7D9C6] text-ink active:bg-[#d9c8ae]' : 'bg-[#E7D9C6]/50 text-ink/40'"
                  >Пересчитать по анкете</button>

                  <button
                    @click="saveCustomPal"
                    :disabled="!customPalChanged || !!customPalError || savingPal"
                    class="w-full py-3 rounded-2xl text-15 font-semibold transition-colors"
                    :class="customPalChanged && !customPalError ? 'bg-ink text-cream active:bg-[#2a1a10]' : 'bg-ink/30 text-cream/70'"
                  >{{ savingPal ? 'Сохраняю...' : 'Сохранить' }}</button>
                </div>
              </template>

              <!-- Настройка дефицита -->
              <template v-if="popupType === 'customDeficit'">
                <div class="text-14 text-ink leading-relaxed">
                  <p class="mb-4">Рекомендуемый дефицит калорий при похудении ~15%. Но {{ ty ? 'ты можешь' : 'вы можете' }} установить комфортный для {{ ty ? 'тебя' : 'вас' }} размер дефицита.</p>

                  <label class="flex items-start gap-2.5 mb-5 cursor-pointer" @click="deficitShowMark = !deficitShowMark">
                    <span class="shrink-0 w-5 h-5 mt-0.5 rounded border flex items-center justify-center transition-colors"
                          :style="{ background: deficitShowMark ? '#41291A' : '#fff', borderColor: deficitShowMark ? '#41291A' : '#C4B8A8' }">
                      <svg v-if="deficitShowMark" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                    </span>
                    <span class="text-14 text-ink">Показывать отсечку дефицита на шкале ккал</span>
                  </label>

                  <div class="mb-2 text-center text-20 font-bold text-ink">{{ deficitSlider }}%</div>
                  <input
                    v-model.number="deficitSlider"
                    type="range"
                    min="-20"
                    max="0"
                    step="5"
                    class="deficit-slider w-full mb-2"
                  />
                  <div class="flex justify-between text-12 text-ink mb-3">
                    <span>-20%</span><span>0%</span>
                  </div>

                  <div class="deficit-hint-box mb-5">
                    <p class="text-13 text-ink/70 leading-snug">{{ deficitHint }}</p>
                  </div>

                  <button
                    @click="saveDeficitAndClose"
                    :disabled="!deficitChanged"
                    class="w-full py-3 rounded-2xl text-15 font-semibold transition-colors"
                    :class="deficitChanged ? 'bg-ink text-cream active:bg-[#2a1a10]' : 'bg-ink/30 text-cream/70'"
                  >Сохранить</button>
                </div>
              </template>

              <!-- Настройка нормы белка -->
              <template v-if="popupType === 'customProtein'">
                <div class="text-14 text-ink leading-relaxed">
                  <p class="mb-4">Норма белка рассчитана по {{ ty ? 'твоим' : 'вашим' }} параметрам. {{ ty ? 'Ты можешь' : 'Вы можете' }} указать норму вручную:</p>

                  <div class="flex justify-center gap-3 items-center mb-2">
                    <input v-model="customProteinMinInput" type="text" inputmode="numeric"
                      class="w-24 h-12 text-center text-20 font-bold rounded-2xl bg-white text-ink outline-none" />
                    <span class="text-16 text-ink/70">–</span>
                    <input v-model="customProteinMaxInput" type="text" inputmode="numeric"
                      class="w-24 h-12 text-center text-20 font-bold rounded-2xl bg-white text-ink outline-none" />
                    <span class="text-14 text-ink/70">г</span>
                  </div>
                  <p v-if="macroMinMaxError('protein')" class="text-13 text-red-500 text-center mb-3">{{ macroMinMaxError('protein') }}</p>
                  <div v-else class="mb-6"></div>

                  <button @click="resetMacroToFormula('protein')" :disabled="!macroDiffersFromFormula('protein')"
                    class="w-full py-3 rounded-2xl text-15 font-semibold mb-3 transition-colors"
                    :class="macroDiffersFromFormula('protein') ? 'bg-[#E7D9C6] text-ink active:bg-[#d9c8ae]' : 'bg-[#E7D9C6]/50 text-ink/40'"
                  >Пересчитать по формуле</button>

                  <button @click="saveCustomMacro('protein')" :disabled="!macroChanged('protein') || !!macroMinMaxError('protein') || savingMacro"
                    class="w-full py-3 rounded-2xl text-15 font-semibold transition-colors"
                    :class="macroChanged('protein') && !macroMinMaxError('protein') ? 'bg-ink text-cream active:bg-[#2a1a10]' : 'bg-ink/30 text-cream/70'"
                  >{{ savingMacro ? 'Сохраняю...' : 'Сохранить' }}</button>
                </div>
              </template>

              <!-- Настройка нормы жиров -->
              <template v-if="popupType === 'customFat'">
                <div class="text-14 text-ink leading-relaxed">
                  <p class="mb-4">Норма жиров рассчитана по {{ ty ? 'твоим' : 'вашим' }} параметрам. {{ ty ? 'Ты можешь' : 'Вы можете' }} указать норму вручную:</p>

                  <div class="flex justify-center gap-3 items-center mb-2">
                    <input v-model="customFatMinInput" type="text" inputmode="numeric"
                      class="w-24 h-12 text-center text-20 font-bold rounded-2xl bg-white text-ink outline-none" />
                    <span class="text-16 text-ink/70">–</span>
                    <input v-model="customFatMaxInput" type="text" inputmode="numeric"
                      class="w-24 h-12 text-center text-20 font-bold rounded-2xl bg-white text-ink outline-none" />
                    <span class="text-14 text-ink/70">г</span>
                  </div>
                  <p v-if="macroMinMaxError('fat')" class="text-13 text-red-500 text-center mb-3">{{ macroMinMaxError('fat') }}</p>
                  <div v-else class="mb-6"></div>

                  <button @click="resetMacroToFormula('fat')" :disabled="!macroDiffersFromFormula('fat')"
                    class="w-full py-3 rounded-2xl text-15 font-semibold mb-3 transition-colors"
                    :class="macroDiffersFromFormula('fat') ? 'bg-[#E7D9C6] text-ink active:bg-[#d9c8ae]' : 'bg-[#E7D9C6]/50 text-ink/40'"
                  >Пересчитать по формуле</button>

                  <button @click="saveCustomMacro('fat')" :disabled="!macroChanged('fat') || !!macroMinMaxError('fat') || savingMacro"
                    class="w-full py-3 rounded-2xl text-15 font-semibold transition-colors"
                    :class="macroChanged('fat') && !macroMinMaxError('fat') ? 'bg-ink text-cream active:bg-[#2a1a10]' : 'bg-ink/30 text-cream/70'"
                  >{{ savingMacro ? 'Сохраняю...' : 'Сохранить' }}</button>
                </div>
              </template>

              <!-- Настройка нормы углеводов -->
              <template v-if="popupType === 'customCarbs'">
                <div class="text-14 text-ink leading-relaxed">
                  <p class="mb-4">Норма углеводов рассчитана по {{ ty ? 'твоим' : 'вашим' }} параметрам. {{ ty ? 'Ты можешь' : 'Вы можете' }} указать норму вручную:</p>

                  <div class="flex justify-center gap-3 items-center mb-2">
                    <input v-model="customCarbsMinInput" type="text" inputmode="numeric"
                      class="w-24 h-12 text-center text-20 font-bold rounded-2xl bg-white text-ink outline-none" />
                    <span class="text-16 text-ink/70">–</span>
                    <input v-model="customCarbsMaxInput" type="text" inputmode="numeric"
                      class="w-24 h-12 text-center text-20 font-bold rounded-2xl bg-white text-ink outline-none" />
                    <span class="text-14 text-ink/70">г</span>
                  </div>
                  <p v-if="macroMinMaxError('carbs')" class="text-13 text-red-500 text-center mb-3">{{ macroMinMaxError('carbs') }}</p>
                  <div v-else class="mb-6"></div>

                  <button @click="resetMacroToFormula('carbs')" :disabled="!macroDiffersFromFormula('carbs')"
                    class="w-full py-3 rounded-2xl text-15 font-semibold mb-3 transition-colors"
                    :class="macroDiffersFromFormula('carbs') ? 'bg-[#E7D9C6] text-ink active:bg-[#d9c8ae]' : 'bg-[#E7D9C6]/50 text-ink/40'"
                  >Пересчитать по формуле</button>

                  <button @click="saveCustomMacro('carbs')" :disabled="!macroChanged('carbs') || !!macroMinMaxError('carbs') || savingMacro"
                    class="w-full py-3 rounded-2xl text-15 font-semibold transition-colors"
                    :class="macroChanged('carbs') && !macroMinMaxError('carbs') ? 'bg-ink text-cream active:bg-[#2a1a10]' : 'bg-ink/30 text-cream/70'"
                  >{{ savingMacro ? 'Сохраняю...' : 'Сохранить' }}</button>
                </div>
              </template>

              <button v-if="!['customKcal','customActivity','customDeficit','customProtein','customFat','customCarbs'].includes(popupType)" @click="closePopup" class="mt-4 w-full py-3 rounded-2xl bg-ink text-cream text-15 font-semibold">
                Понятно
              </button>
            </div>

          </div>
        </div>
      </Transition>
    </Teleport>
  </div>
</template>

<script setup>
import { JOB_SHORT, WORK_TYPE_SHORT } from '../utils/activityJobs.js'
import { computed, ref, watch, onMounted } from 'vue'
import { Capacitor } from '@capacitor/core'
import { useAuthStore } from '../store/auth.js'
import { iosSalesDisabled } from '../services/sales.js'
import { displayEmail } from '../utils/displayEmail.js'
import api from '../services/api.js'
import { imgUrl } from '../utils/image.js'
import ProfileAvatarPlaceholder from '../components/ProfileAvatarPlaceholder.vue'

const authStore = useAuthStore()

// После входа (гость → авторизован) прокручиваем страницу наверх
watch(() => authStore.isGuest, (isGuest, wasGuest) => {
  if (wasGuest && !isGuest) window.scrollTo(0, 0)
})

const popupType = ref(null) // 'formula' | 'method' | 'sources' | null
const lastBodyFat = ref(null)
const avatarBroken = ref(false)

const avatarDisplaySrc = computed(() => {
  if (authStore.avatarThumb) return authStore.avatarThumb
  if (authStore.user?.avatar_url) return imgUrl(authStore.user.avatar_url)
  return null
})

// Показывать баннер установки только если открыто в браузере (не PWA / не TWA)
const isStandalone = window.matchMedia('(display-mode: standalone)').matches
  || window.matchMedia('(display-mode: fullscreen)').matches
  || window.navigator.standalone === true
  || Capacitor.isNativePlatform()
const showInstallBanner = computed(() => !isStandalone)

// ── Подписка: статус-бейдж ────────────────────────────
const subState = computed(() => {
  const user = authStore.user
  if (!user?.id) return 'no_sub'
  const now = new Date()
  const subEnd = user.subscription_end ? new Date(user.subscription_end) : null

  if (subEnd) {
    if (subEnd > now) {
      if (user.subscription_plan === '12_months') return 'annual_active'
      if (user.subscription_plan === '1_month' && user.has_rebill) return 'monthly_active'
      if (user.subscription_plan === '1_month' && user.charge_failed) return 'past_due'
      if (user.subscription_plan === '1_month') return 'monthly_cancelled'
      return 'annual_active'
    }
    if (user.charge_failed && user.subscription_plan === '1_month') return 'past_due'
    return 'no_sub'
  }

  const trialEnd = user.created_at ? new Date(new Date(user.created_at).getTime() + 3 * 86400000) : null
  if (trialEnd && now < trialEnd) return 'trial'
  return 'no_sub'
})

const subBadgeLabel = computed(() => {
  const labels = {
    trial: 'Пробный период',
    no_sub: 'Без подписки',
    monthly_active: 'Подписка активна',
    monthly_cancelled: 'Подписка отменена',
    // Вариант B (services/sales.js): в iOS-сборке статус без слова «оплата».
    past_due: iosSalesDisabled ? 'Премиум приостановлен' : 'Проблема с оплатой',
    annual_active: 'Годовой доступ',
  }
  return labels[subState.value] || 'Без подписки'
})

const subBadgeClass = computed(() => {
  const classes = {
    trial: 'sub-badge--ok',
    monthly_active: 'sub-badge--ok',
    annual_active: 'sub-badge--ok',
    monthly_cancelled: '',
    past_due: 'sub-badge--warn',
    no_sub: '',
  }
  return classes[subState.value] || ''
})

// Загрузить последний % жира
onMounted(async () => {
  if (!authStore.user) return
  try {
    const { data } = await api.get('/weight/body-fat/history', { params: { limit: 1 } })
    if (data.length > 0) lastBodyFat.value = parseFloat(data[0].body_fat_percent).toFixed(1)
  } catch { /* silent */ }
})

// Блокировка скролла при попапе (включая iOS)
let savedScrollY = 0
function openPopup(type) {
  if (type === 'customKcal') customKcalInput.value = String(effectiveKcalNorm.value)
  if (type === 'customActivity') customPalInput.value = String(effectiveActivityCoefficient.value || '')
  if (type === 'customDeficit') {
    deficitSlider.value = effectiveDeficitPct.value
    deficitShowMark.value = !!u.value.show_deficit_mark
    deficitInitSlider.value = effectiveDeficitPct.value
    deficitInitShowMark.value = !!u.value.show_deficit_mark
  }
  if (type === 'customProtein') {
    customProteinMinInput.value = String(effectiveProteinMin.value)
    customProteinMaxInput.value = String(effectiveProteinMax.value)
  }
  if (type === 'customFat') {
    customFatMinInput.value = String(effectiveFatMin.value)
    customFatMaxInput.value = String(effectiveFatMax.value)
  }
  if (type === 'customCarbs') {
    customCarbsMinInput.value = String(effectiveCarbsMin.value)
    customCarbsMaxInput.value = String(effectiveCarbsMax.value)
  }
  popupType.value = type
  savedScrollY = window.scrollY
  document.body.style.position = 'fixed'
  document.body.style.top = `-${savedScrollY}px`
  document.body.style.left = '0'
  document.body.style.right = '0'
  document.body.style.overflow = 'hidden'
}
function closePopup() {
  popupType.value = null
  document.body.style.position = ''
  document.body.style.top = ''
  document.body.style.left = ''
  document.body.style.right = ''
  document.body.style.overflow = ''
  window.scrollTo(0, savedScrollY)
}

const initials = computed(() => {
  const n = authStore.user?.name || ''
  return n.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()
})

const u = computed(() => authStore.user || {})
const ty = computed(() => u.value.address_form !== 'вы')
const hasNorms = computed(() => !!u.value.kcal_intake_norm)

// Четыре поля, без любого из которых recalcNorms на сервере молча выходит.
// Пустая карточка «Норма калорий» называет недостающее по имени — общий
// «заполните разделы выше» не говорил, что дело, например, в поле пола,
// которого в карточке «Моё тело» не видно.
const missingNormFields = computed(() => {
  const missing = []
  if (!u.value.sex) missing.push('пол')
  if (!u.value.birth_date) missing.push('дата рождения')
  if (!u.value.height_cm) missing.push('рост')
  if (!u.value.weight_kg) missing.push('вес')
  return missing
})
const missingNormFieldsText = computed(() => {
  const m = missingNormFields.value
  return m.length > 1 ? m.slice(0, -1).join(', ') + ' и ' + m[m.length - 1] : m[0]
})
const effectiveKcalNorm = computed(() => u.value.custom_kcal_norm || u.value.kcal_intake_norm || 0)
const effectiveDeficitPct = computed(() => u.value.custom_deficit_pct != null ? u.value.custom_deficit_pct : 0)
const deficitKcal = computed(() => Math.round(effectiveKcalNorm.value * (1 + effectiveDeficitPct.value / 100)))

// ── Настройка нормы ккал ──────────────────────────
const customKcalInput = ref('')
const savingKcal = ref(false)
const kcalChanged = computed(() => {
  const v = parseInt(customKcalInput.value)
  return !isNaN(v) && v !== effectiveKcalNorm.value
})
const kcalDiffersFromFormula = computed(() => {
  const v = parseInt(customKcalInput.value)
  return !isNaN(v) && v !== u.value.kcal_intake_norm
})
const kcalBelowBmr = computed(() => {
  const v = parseInt(customKcalInput.value)
  return !isNaN(v) && u.value.basal_met && v < u.value.basal_met
})

function resetKcalToFormula() {
  customKcalInput.value = String(u.value.kcal_intake_norm || '')
}

async function saveCustomKcal() {
  const v = parseInt(customKcalInput.value)
  if (isNaN(v) || kcalBelowBmr.value) return
  savingKcal.value = true
  try {
    // If value equals formula, reset to null (auto)
    const val = v === u.value.kcal_intake_norm ? null : v
    await authStore.updateProfile({ custom_kcal_norm: val })
    closePopup()
  } catch (err) {
    console.error('Save custom kcal error:', err)
  } finally {
    savingKcal.value = false
  }
}

// ── Ручной коэффициент активности ──────────────────
// По образцу нормы ккал: расчётное значение остаётся в activity_coefficient,
// ручное — в custom_activity_coefficient, нормы сервер считает от ручного.
const customPalInput = ref('')
const savingPal = ref(false)
const parsedCustomPal = computed(() => {
  const raw = String(customPalInput.value || '').trim().replace(',', '.')
  if (!raw) return NaN
  return Math.round(parseFloat(raw) * 100) / 100
})
const customPalError = computed(() => {
  const v = parsedCustomPal.value
  if (isNaN(v)) return 'Введите число, например 1.6'
  if (v < 1.1 || v > 2.5) return 'Допустимо от 1.1 до 2.5'
  return ''
})
const customPalLow = computed(() => !customPalError.value && parsedCustomPal.value < 1.4)
const customPalPreview = computed(() =>
  (!customPalError.value && u.value.basal_met) ? Math.round(u.value.basal_met * parsedCustomPal.value) : null)
const customPalChanged = computed(() => !customPalError.value && parsedCustomPal.value !== effectiveActivityCoefficient.value)
const customPalDiffersFromFormula = computed(() => !isNaN(parsedCustomPal.value) && parsedCustomPal.value !== u.value.activity_coefficient)

function resetCustomPal() {
  customPalInput.value = String(u.value.activity_coefficient || '')
}

async function saveCustomPal() {
  if (customPalError.value) return
  savingPal.value = true
  try {
    // Совпало с расчётом по анкете — ручное значение снимается (null), как у нормы ккал
    const val = parsedCustomPal.value === u.value.activity_coefficient ? null : parsedCustomPal.value
    await authStore.updateProfile({ custom_activity_coefficient: val })
    closePopup()
  } catch (err) {
    console.error('Save custom PAL error:', err)
  } finally {
    savingPal.value = false
  }
}

// ── Настройка норм БЖУ ──────────────────────────
const effectiveProteinMin = computed(() => u.value.custom_protein_norm_min || u.value.protein_norm_min || 0)
const effectiveProteinMax = computed(() => u.value.custom_protein_norm_max || u.value.protein_norm_max || 0)
const effectiveFatMin = computed(() => u.value.custom_fat_norm_min || u.value.fat_norm_min || 0)
const effectiveFatMax = computed(() => u.value.custom_fat_norm_max || u.value.fat_norm_max || 0)
const effectiveCarbsMin = computed(() => u.value.custom_carbs_norm_min || u.value.carbs_norm_min || 0)
const effectiveCarbsMax = computed(() => u.value.custom_carbs_norm_max || u.value.carbs_norm_max || 0)

const customProteinMinInput = ref('')
const customProteinMaxInput = ref('')
const customFatMinInput = ref('')
const customFatMaxInput = ref('')
const customCarbsMinInput = ref('')
const customCarbsMaxInput = ref('')
const savingMacro = ref(false)

const macroInputs = {
  protein: { min: customProteinMinInput, max: customProteinMaxInput },
  fat:     { min: customFatMinInput,     max: customFatMaxInput },
  carbs:   { min: customCarbsMinInput,   max: customCarbsMaxInput },
}
const macroEffective = {
  protein: { min: effectiveProteinMin, max: effectiveProteinMax },
  fat:     { min: effectiveFatMin,     max: effectiveFatMax },
  carbs:   { min: effectiveCarbsMin,   max: effectiveCarbsMax },
}
const macroFormula = {
  protein: { min: () => u.value.protein_norm_min, max: () => u.value.protein_norm_max },
  fat:     { min: () => u.value.fat_norm_min,     max: () => u.value.fat_norm_max },
  carbs:   { min: () => u.value.carbs_norm_min,   max: () => u.value.carbs_norm_max },
}

function macroMinMaxError(macro) {
  const minV = parseInt(macroInputs[macro].min.value)
  const maxV = parseInt(macroInputs[macro].max.value)
  if (isNaN(minV) || isNaN(maxV)) return 'Введите числовые значения'
  if (minV < 1 || maxV < 1) return 'Значение должно быть больше 0'
  if (minV > maxV) return 'Минимум не может быть больше максимума'
  return ''
}

function macroChanged(macro) {
  const minV = parseInt(macroInputs[macro].min.value)
  const maxV = parseInt(macroInputs[macro].max.value)
  return !isNaN(minV) && !isNaN(maxV) && (minV !== macroEffective[macro].min.value || maxV !== macroEffective[macro].max.value)
}

function macroDiffersFromFormula(macro) {
  const minV = parseInt(macroInputs[macro].min.value)
  const maxV = parseInt(macroInputs[macro].max.value)
  return !isNaN(minV) && !isNaN(maxV) && (minV !== macroFormula[macro].min() || maxV !== macroFormula[macro].max())
}

function resetMacroToFormula(macro) {
  macroInputs[macro].min.value = String(macroFormula[macro].min() || '')
  macroInputs[macro].max.value = String(macroFormula[macro].max() || '')
}

async function saveCustomMacro(macro) {
  const minV = parseInt(macroInputs[macro].min.value)
  const maxV = parseInt(macroInputs[macro].max.value)
  if (isNaN(minV) || isNaN(maxV) || macroMinMaxError(macro)) return
  savingMacro.value = true
  try {
    const fields = {}
    // If values match formula, reset to null (auto)
    const minKey = `custom_${macro}_norm_min`
    const maxKey = `custom_${macro}_norm_max`
    fields[minKey] = minV === macroFormula[macro].min() ? null : minV
    fields[maxKey] = maxV === macroFormula[macro].max() ? null : maxV
    await authStore.updateProfile(fields)
    closePopup()
  } catch (err) {
    console.error(`Save custom ${macro} error:`, err)
  } finally {
    savingMacro.value = false
  }
}

// ── Настройка дефицита ────────────────────────────
const deficitSlider = ref(0)
const deficitShowMark = ref(false)
const deficitInitSlider = ref(0)
const deficitInitShowMark = ref(false)

const deficitChanged = computed(() =>
  deficitSlider.value !== deficitInitSlider.value || deficitShowMark.value !== deficitInitShowMark.value
)

const DEFICIT_HINTS = {
  0: 'Нет дефицита — нет снижения веса. И наоборот: если нет снижения веса, значит нет дефицита',
  '-5': 'Медленное похудение: ~0.4 кг в месяц',
  '-10': 'Похудение со средней скоростью ~0.8 кг в месяц',
  '-15': 'Оптимальный дефицит. Похудение со средней скоростью ~1.2 кг в месяц',
  '-20': 'Высокий уровень дефицита. Не рекомендуется при низкой активности. Более высокий дефицит связан с расстройствами нервной системы, срывами и низкой общей эффективностью',
}
const deficitHint = computed(() => DEFICIT_HINTS[String(deficitSlider.value)] || '')

async function saveDeficitAndClose() {
  if (!deficitChanged.value) return
  try {
    const fields = {}
    if (deficitSlider.value !== deficitInitSlider.value) {
      fields.custom_deficit_pct = deficitSlider.value === 0 ? 0 : deficitSlider.value
    }
    if (deficitShowMark.value !== deficitInitShowMark.value) {
      fields.show_deficit_mark = deficitShowMark.value
    }
    if (Object.keys(fields).length > 0) {
      await authStore.updateProfile(fields)
    }
    closePopup()
  } catch (err) {
    console.error('Save deficit error:', err)
  }
}

// ── Физическая активность ─────────────────────────────
const TYPE_LABELS = {
  strength: '🏋️ Силовые тренировки', running: '🏃 Бег / интенсивное кардио',
  cycling: '🚴 Велоспорт / велотренажёр', crossfit: '🤸‍♀️ Функциональные / кроссфит / ВИИТ',
  team: '⚽️ Командные виды спорта', racket: '🎾 Ракеточные виды спорта',
  martial: '🥊 Единоборства', swimming: '🏊 Плавание',
  yoga: '🧘 Йога', dance: '💃 Танцы / групповые занятия',
  home: '📱 Домашние тренировки', other: '🏅 Другое',
}
const FREQ_LABELS = { '1': '1 р./нед.', '2-3': '2-3 р./нед.', '4-5': '4-5 р./нед.', daily: 'каждый день' }
const DUR_LABELS = { '20': '20 мин', '30': '30 мин', '45': '45 мин', '60': '1 ч', '90': '1.5 ч', '120': '2 ч', '120+': '2+ ч' }

const hasActivity = computed(() => !!u.value.physical_activity)
// Короткая выжимка для карточки: отмеченные пункты плюс свободная строка
const nutritionSummary = computed(() => {
  const n = u.value?.nutrition_notes
  if (!n) return ''
  return [...(n.selected || []), n.note].filter(Boolean).join(', ')
})

// Полосы FAO/WHO/UNU (Human Energy Requirements, 2004) — те же, по которым
// считает lib/pal.js: 1.40–1.69 сидячий или лёгкий образ жизни, 1.70–1.99
// умеренный, 2.00–2.40 высокий.
//
// Прежние пороги остались от старой шкалы и разъехались с расчётом на целую
// полосу: 1.58 подписывалось как «умеренная нагрузка», хотя рядом стояло
// «работа сидячая, офисная». Человек видел противоречие и справедливо не
// верил числу. Ветка «малоподвижный» (≤1.3) вдобавок была недостижима —
// PAL_MIN в расчёте равен 1.35.
// Какой формулой посчитан коэффициент этого человека (lib/pal.js, две версии)
const palV2 = computed(() => u.value?.pal_version === 2)
// Закреплён на прежней при переходе по согласию — предлагаем новую
const palOfferAvailable = computed(() => u.value?.pal_version === 1)
const savingPalVersion = ref(false)
async function acceptPalV2() {
  savingPalVersion.value = true
  try {
    await authStore.updateProfile({ pal_version: 2 })
  } catch (err) {
    console.error('Accept PAL v2 error:', err)
  } finally {
    savingPalVersion.value = false
  }
}
// Ручной коэффициент важнее расчётного — по нему посчитаны нормы (recalcNorms)
const effectiveActivityCoefficient = computed(() => u.value.custom_activity_coefficient || u.value.activity_coefficient || null)
const activityLabel = computed(() => {
  const c = effectiveActivityCoefficient.value
  if (!c) return ''
  if (c < 1.70) return 'сидячая или лёгкая активность'
  if (c < 2.00) return 'умеренная активность'
  return 'высокая активность'
})
const activityPills = computed(() => {
  const pa = u.value.physical_activity
  if (!pa) return []
  const pills = []
  // Своими словами, как в анкете: новая — вид работы, старая — прежний вариант
  const work = pa.job ? JOB_SHORT[pa.job] : WORK_TYPE_SHORT[pa.work_type]
  if (work) pills.push({ label: 'Обычный день', value: work })
  // Старый «Активный» смешивал работу стоя и физический труд — просим уточнить
  if (!pa.job && pa.work_type === 'heavy') pills.push({ label: 'Уточните в анкете', value: 'на ногах или физический труд?' })
  if (pa.steps) pills.push({ label: 'Ходьба', value: `${pa.steps.toLocaleString('ru-RU')} шагов / день` })
  if (pa.activities) {
    for (const a of pa.activities) {
      // Для "Другое" показываем текст пользователя вместо слова "Другое"
      const name = a.type === 'other' && a.other_text ? a.other_text : (TYPE_LABELS[a.type] || a.type)
      const freq = FREQ_LABELS[a.freq] || a.freq
      const dur = DUR_LABELS[a.duration] || a.duration
      pills.push({ label: name, value: `${freq} по ${dur}` })
    }
  }
  return pills
})

// ── Цели ──────────────────────────────────────────────
const GOAL_LABELS = {
  // Old system (existing prod users)
  analyze: 'Проанализировать рацион',
  lose_significant: 'Значительно похудеть',
  lose_small: 'Немного снизить вес',
  gain: 'Набрать мышечную массу',
  longevity: 'Активное долголетие',
  skin: 'Здоровье кожи',
  hair: 'Здоровье волос',
  water: 'Водный баланс',
  energy: 'Активность и радость жизни',
  mental: 'Психологическое здоровье',
  sport: 'Спортивные цели',
  // New system — masha
  plate: 'Питание по Методу Тарелки',
  trig: 'Замечать триггеры переедания',
  body: 'Слышать сигналы голода и сытости',
  swing: 'Выйти из качелей «ограничение — срыв»',
  care: 'Забота о себе',
  // New system — control / sport
  full: 'Контроль питания по цифрам',
  cut: 'Снижение веса',
  bulk: 'Набор мышечной массы',
  recomp: 'Рекомпозиция',
  maintain: 'Поддержание веса',
  endurance: 'Выносливость и восстановление',
}
const hasGoals = computed(() => {
  const gd = u.value.goals_data
  return gd?.selected?.length > 0 || !!gd?.own_goal
})
const goalPills = computed(() => {
  const gd = u.value.goals_data
  if (!gd?.selected) return []
  const pills = gd.selected.map(k => GOAL_LABELS[k] || k)
  if (gd.own_goal) pills.push(gd.own_goal)
  if (gd.measurable_goal) pills.push(gd.measurable_goal)
  if (gd.sport_goal) pills.push(gd.sport_goal)
  return pills
})
</script>

<style scoped>
.pill-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px;
  padding: 8px 12px;
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: var(--fs-14);
  color: var(--ink);
  margin-bottom: 4px;
}
.pill-main { background: #EBE5D9; }
/* Подписи как у меток полосок дневника (Inter 600) */
.pill-bold { font-weight: 600; }
.pill-basal { background: rgba(226, 149, 120, 0.6); }

/* ── Empty state cards ── */
.empty-card {
  border-radius: 16px;
  padding: 16px 18px;
}
.empty-card-brown {
  background: rgba(65, 41, 26, 0.2);
}
.empty-card-gold {
  background: #EBC06D;
}
.empty-card-peach {
  background: #EEBFAE;
}
.empty-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.empty-card-title {
  font-size: var(--fs-20);
  font-weight: 700;
  line-height: 1.1;
  color: var(--ink);
}
.empty-card-action {
  display: flex;
  align-items: center;
  gap: 4px;
}
.empty-card-link {
  font-size: var(--fs-15);
  font-weight: 400;
  color: var(--ink);
}
.empty-card-desc {
  font-size: var(--fs-14);
  color: var(--ink);
  margin-top: 8px;
  line-height: 1.4;
}

/* ── Section header with info button ── */
.section-header {
  display: flex;
  align-items: center;
  gap: 6px;
}
.info-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
}

.fade-enter-active, .fade-leave-active { transition: opacity 0.2s; }
.fade-enter-from, .fade-leave-to { opacity: 0; }

/* ── Deficit slider ── */
.deficit-slider {
  -webkit-appearance: none;
  appearance: none;
  height: 6px;
  border-radius: 3px;
  background: #E7D9C6;
  outline: none;
}
.deficit-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #41291A;
  cursor: pointer;
  border: 3px solid #FAF3E8;
  box-shadow: 0 1px 4px rgba(0,0,0,0.2);
}
.deficit-hint-box {
  min-height: 72px;
  display: flex;
  align-items: flex-start;
}
.deficit-slider::-moz-range-thumb {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #41291A;
  cursor: pointer;
  border: 3px solid #FAF3E8;
  box-shadow: 0 1px 4px rgba(0,0,0,0.2);
}

/* ── Subscription badge ── */
.sub-badge {
  display: inline-block;
  margin-top: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid rgba(65,41,26,0.12);
  font-size: var(--fs-11);
  font-weight: 500;
  background: #FBF8F3;
  color: var(--ink-70);
}
.sub-badge--ok {
  background: #E7D9C6;
  color: var(--ink);
}
.sub-badge--warn {
  background: #F0E3DC;
  color: var(--error);
}
</style>
